const moduleName = "finance/profit/";
export default {
    id: {
        id: "FINANCIAL_MANAGEMENT_REALTIME_PROFIT_DETAIL",
        name: "发货单毛利明细",
        type: "menu_hide"
    },
    children: {}
};
